import React from 'react';
import '../styles/header.css';

const Header: React.FC = () => {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    element?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="header-container">
      <div className="h1-container">
        <h1 className="header-h1">I'm Anas Wail Tafish</h1>
        <p className="header-tagline">Full Stack Developer • UI Designer • Problem Solver</p>
        
        <p className="header-description">
          I create beautiful, user-friendly web applications and solve complex problems with clean,
          efficient code. Currently exploring Machine Learning and AI.
        </p>

        <div className="header-cta">
          <button className="btn btn-primary" onClick={() => scrollToSection('projects')}>
            View My Work
          </button>
          <button className="btn btn-secondary" onClick={() => scrollToSection('contact')}>
            Get In Touch
          </button>
        </div>

        <div className="header-scroll-hint">
          <p>Scroll to explore</p>
        </div>
      </div>
    </div>
  );
};

export default Header;

